export default {
    controller: 'orderHistoryController',
    template: require('../views/order.history.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/components/order.history.component.js